export default __webpack_public_path__ + "static/media/select-dropdown-icon.9c72574e.svg";